import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check } from "lucide-react";

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16" data-testid="services-page">
      <div className="overline text-[#FFB800]">Services</div>
      <h1 className="font-display text-4xl sm:text-5xl mt-2 max-w-3xl leading-tight">
        Certified processes.<br />Lifetime-warranty PPF available.
      </h1>
      <p className="text-zinc-400 mt-4 max-w-xl text-sm">Deep-dive into each service and pick the package that fits your car and use-case. Lifetime warranty on select PPF films (T&amp;C apply).</p>

      <div className="mt-14 space-y-16">
        {services.map((s, idx) => (
          <div key={s.id} data-testid={`service-block-${s.id}`}>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="md:col-span-1">
                <div className="overline">Service {String(idx + 1).padStart(2, "0")}</div>
                <h2 className="font-display text-3xl mt-3">{s.name}</h2>
                <p className="text-zinc-400 text-sm mt-3">{s.description}</p>
                <Link to={`/quote?service=${s.id}`} className="btn-outline mt-6 inline-flex" data-testid={`svc-quote-${s.id}`}>
                  Quote this service
                </Link>
              </div>
              <div className="md:col-span-2 grid sm:grid-cols-2 gap-4">
                {s.packages.map((p) => (
                  <div key={p.id} className="card-surface rounded-lg p-6" data-testid={`pkg-${p.id}`}>
                    <div className="flex items-center justify-between">
                      <div className="font-display text-lg">{p.name}</div>
                      <div className="font-mono text-[#FFB800] text-sm">₹{p.price.toLocaleString()}</div>
                    </div>
                    <div className="mt-4 space-y-1.5 text-sm text-zinc-400">
                      <div className="flex items-center gap-2"><Check className="h-3.5 w-3.5 text-[#FFB800]" /> {p.duration_days} day{p.duration_days > 1 ? "s" : ""} turnaround</div>
                      {p.warranty_years > 0 && (
                        <div className="flex items-center gap-2"><Check className="h-3.5 w-3.5 text-[#FFB800]" /> {p.warranty_years}-year warranty</div>
                      )}
                      <div className="flex items-center gap-2"><Check className="h-3.5 w-3.5 text-[#FFB800]" /> Documented process</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-10 border-t border-zinc-900" />
          </div>
        ))}
      </div>
    </div>
  );
}
